export default __webpack_public_path__ + "images/ac-splash-full.jpg";